import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '钻取',
    type: 'AMAR_DRILL',
    mapProp: 'map',
}